import React from 'react';
import { Brain, Gift } from 'lucide-react';
export function ExtraBonusSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#1a2e1a]" data-id="element-54">
      <div className="max-w-2xl mx-auto" data-id="element-55">
        <div className="relative bg-gradient-to-br from-[#243824] to-[#1a2e1a] border-2 border-[#c8e6c9]/40 rounded-2xl pt-10 pb-7 px-6 md:px-8 shadow-[0_0_30px_rgba(200,230,201,0.08)]" data-id="element-56">
          {/* Floating badge - not clipped */}
          <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#c8e6c9] text-[#1a2e1a] text-[10px] md:text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-lg flex items-center gap-1.5 whitespace-nowrap" data-id="element-57">
            <Gift className="w-3 h-3" data-id="element-58" /> Bono extra
          </div>

          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left" data-id="element-59">
            <div className="flex-shrink-0 w-14 h-14 bg-[#2e7d32]/20 border border-[#c8e6c9]/30 rounded-xl flex items-center justify-center" data-id="element-60">
              <Brain className="w-7 h-7 text-[#c8e6c9]" data-id="element-61" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-62">
              <p className="text-[#c8e6c9] text-[11px] font-bold uppercase tracking-wider mb-1.5" data-id="element-63">
                Incluido sin costo
              </p>
              <h3 className="font-heading text-lg md:text-xl font-black text-[#faf5e8] leading-snug mb-2" data-id="element-64">
                Psicología Deportiva
              </h3>
              <p className="text-[#d4d0c4] text-sm md:text-base leading-relaxed" data-id="element-65">
                Cómo enfrentar las{' '}
                <span className="text-[#faf5e8] font-semibold" data-id="element-66">derrotas</span> y
                las{' '}
                <span className="text-[#c8e6c9] font-semibold" data-id="element-67">victorias</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}